import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { IDataSourceBackendParam, IDocumentDataSourceBackendParam, IPatientDocInfo } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { DocumentApiService } from "src/app/providers/api/document-api.service";

export class DocumentsDataSource extends MatTableDataSourceBackendExtended<IPatientDocInfo> {
  constructor(private documentApi: DocumentApiService) {
    super();
  }

  public data(params: IDocumentDataSourceBackendParam): Observable<IPatientDocInfo[]> {
    return this.documentApi.findDocument(params);
  }
  protected dataCount(_param: IDataSourceBackendParam): Observable<number> {
    /*
      Use this, the day we decide to make the page implements AbstractBackendTablePage
      */
    return of(0);
  }
}
